var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.isDialog,
      "title": _vm.$t('views.report.fleet.FleetAnalyticsView.selectCostCenter'),
      "leftText": _vm.$t('views.report.fleet.FleetAnalyticsView.selectionDialog.cancel'),
      "rightText": _vm.$t('views.report.fleet.FleetAnalyticsView.selectionDialog.apply'),
      "width": '500px'
    },
    on: {
      "leftClick": _vm.close,
      "rightClick": _vm.confirmSelection,
      "close": _vm.close
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('views.report.fleet.FleetAnalyticsView.costCenter'),
      "placeholder": _vm.$t('views.report.fleet.FleetAnalyticsView.enterCostCenter'),
      "clearable": "",
      "outline": ""
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.confirmSelection.apply(null, arguments);
      }
    },
    model: {
      value: _vm.costCenterInput,
      callback: function callback($$v) {
        _vm.costCenterInput = $$v;
      },
      expression: "costCenterInput"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }